var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F36F2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#F14810",
    strokeOpacity: 0.18,
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8329 16.335C23.988 16.335 22.1588 16.4052 20.3473 16.5403C19.6892 16.5913 19.0746 16.8892 18.627 17.3743C18.1793 17.8594 17.9316 18.4958 17.9336 19.1559V29.5004H33.7321V19.1541C33.7321 17.8007 32.6965 16.6439 31.3185 16.5403C29.4932 16.4031 27.6633 16.3346 25.8329 16.335ZM17.9336 32.1335V36.522C17.9336 37.2203 18.211 37.8901 18.7048 38.3839C19.1986 38.8777 19.8684 39.1551 20.5667 39.1551H20.6387C20.844 37.9259 21.4786 36.8093 22.4297 36.0039C23.3808 35.1985 24.5866 34.7566 25.8329 34.7566C27.0791 34.7566 28.285 35.1985 29.2361 36.0039C30.1871 36.8093 30.8217 37.9259 31.0271 39.1551H32.4156C32.7648 39.1551 33.0996 39.0164 33.3465 38.7695C33.5934 38.5226 33.7321 38.1877 33.7321 37.8385V32.1335H17.9336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8335 42.6658C26.5319 42.6658 27.2016 42.3884 27.6954 41.8946C28.1892 41.4008 28.4666 40.7311 28.4666 40.0327C28.4666 39.3344 28.1892 38.6647 27.6954 38.1709C27.2016 37.6771 26.5319 37.3996 25.8335 37.3996C25.1352 37.3996 24.4655 37.6771 23.9717 38.1709C23.4779 38.6647 23.2004 39.3344 23.2004 40.0327C23.2004 40.7311 23.4779 41.4008 23.9717 41.8946C24.4655 42.3884 25.1352 42.6658 25.8335 42.6658ZM37.6824 19.8457C37.3333 19.8457 36.9984 19.9844 36.7515 20.2313C36.5046 20.4782 36.3659 20.8131 36.3659 21.1623V36.1077C37.0343 35.5102 37.8441 35.0933 38.7187 34.8962C39.5933 34.6992 40.5037 34.7286 41.3638 34.9817C42.2238 35.2348 43.005 35.7032 43.6335 36.3426C44.2619 36.982 44.7168 37.7712 44.955 38.6354C45.6045 38.1527 46.0258 37.3733 45.9995 36.4816C45.8477 31.3339 44.7875 26.2535 42.8679 21.4747C42.6724 20.9923 42.3371 20.5794 41.9051 20.2891C41.4731 19.9988 40.9641 19.8444 40.4437 19.8457H37.6824ZM39.8767 42.6658C40.575 42.6658 41.2447 42.3884 41.7385 41.8946C42.2323 41.4008 42.5098 40.7311 42.5098 40.0327C42.5098 39.3344 42.2323 38.6647 41.7385 38.1709C41.2447 37.6771 40.575 37.3996 39.8767 37.3996C39.1783 37.3996 38.5086 37.6771 38.0148 38.1709C37.521 38.6647 37.2436 39.3344 37.2436 40.0327C37.2436 40.7311 37.521 41.4008 38.0148 41.8946C38.5086 42.3884 39.1783 42.6658 39.8767 42.6658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportericon);
export default __webpack_public_path__ + "static/media/transportericon.5b4cf1cf0626d24651dea171e41318e2.svg";
export { ForwardRef as ReactComponent };